import moment from "moment";
import { useReducer } from "react";
import { ICategoryQuery } from "../../models/category/query";
import {
  ICreateCategory,
  IUpdateCategory,
} from "../../models/category/request";
import { ICategory } from "../../models/category/response";
import EndPoints from "../../services/end-points";
import { Permissions } from "../../utils/Permissions/Permissions";
import { execute } from "../../utils/helpers/execute";
import CategoryContext, { internalState } from "./context";
import reducer from "./reducer";

export interface IProps {
  children: React.ReactNode;
}
const CategoryContextProvider: React.FC<IProps> = (props) => {
  const [state, dispatch] = useReducer(reducer, internalState);

  // useEffect(() => {
  //   getAllData();
  // }, [direction]);

  const getAllData = async () => {
    const userPermissions = localStorage
      ?.getItem("permisionStoroge")
      ?.split(",");
    if (
      userPermissions?.length &&
      !userPermissions.includes(Permissions.CAN_VIEW_ALL_CATEGORIES)
    ) {
      return;
    }

    await execute({
      callback: async () => {
        dispatch({ type: "LOADING", payload: { loading: "list" } });

        const { data } = await EndPoints.category.getAllCategories({
          ...state.query,
          perPage: -1,
        });
        dispatch({
          type: "SET_ALL_CATEGORIES",
          payload: {
            data: data.data,
          },
        });
      },
      fallback: () => {},
      finallyCallback: () => {
        dispatch({ type: "LOADING", payload: { loading: "list" } });
      },
      throwException: false,
    });
  };
  const getData = async () => {
    await execute({
      callback: async () => {
        dispatch({ type: "LOADING", payload: { loading: "list" } });

        const { data } = await EndPoints.category.getAllCategories({
          ...state.query,
        });

        dispatch({ type: "SET_LIST", payload: { list: data } });
      },
      fallback: () => {},
      finallyCallback: () => {
        dispatch({ type: "LOADING", payload: { loading: "list" } });
      },
      throwException: false,
    });
  };

  const getDetails = async (id: number) => {
    await execute({
      callback: async () => {
        dispatch({ type: "LOADING", payload: { loading: "details" } });

        const { data } = await EndPoints.category.getCategory(id);

        dispatch({ type: "SET_DETAILSS", payload: { details: data } });
      },
      fallback: (error) => {},
      finallyCallback: () => {
        dispatch({ type: "LOADING", payload: { loading: "details" } });
      },
      throwException: false,
    });
  };

  const setDetails = async (data?: ICategory) => {
    dispatch({ type: "SET_DETAILSS", payload: { details: data } });
  };

  const createCategory = async (request: ICreateCategory) => {
    await execute({
      callback: async () => {
        dispatch({
          type: "LOADING",
          payload: { loading: "create" },
        });

        await EndPoints.category.createCategory(request);
        getAllData();
        // getData();
      },
      fallback: (error) => {},
      finallyCallback: () => {
        dispatch({
          type: "LOADING",
          payload: { loading: "create" },
        });
      },
      throwException: true,
    });
  };

  const updateCategory = async (id: number, request: IUpdateCategory) => {
    await execute({
      callback: async () => {
        dispatch({
          type: "LOADING",
          payload: { loading: "update" },
        });
        await EndPoints.category.updateCategory(id, request);

        getData();
      },
      fallback: (error) => {},
      finallyCallback: () => {
        dispatch({
          type: "LOADING",
          payload: { loading: "update" },
        });
      },
      throwException: true,
    });
  };

    const updateCategoriesArrangementList = async (
      id: number,
      request: {
        "priority":number
      }
    ) => {
      await execute({
        callback: async () => {
          dispatch({
            type: "LOADING",
            payload: { loading: "update" },
          });
          await EndPoints.category.updateCategoriesArrangementList(id, request);
  
          // getData();
        },
        fallback: (error) => {},
        finallyCallback: () => {
          dispatch({
            type: "LOADING",
            payload: { loading: "update" },
          });
        },
        throwException: true,
      });
    };

  const deleteCategory = async (id: number) => {
    await execute({
      callback: async () => {
        dispatch({
          type: "LOADING",
          payload: { loading: "delete" },
        });

        await EndPoints.category.deleteCategory(id);
        getData();
      },
      fallback: (error) => {},
      finallyCallback: () => {
        dispatch({
          type: "LOADING",
          payload: { loading: "delete" },
        });
      },
      throwException: true,
    });
  };

  const setSearch = (search?: string) => {
    dispatch({ type: "SET_SEARCH", payload: { search } });
  };

  const setQuery = (query: ICategoryQuery) => {
    dispatch({ type: "SET_QUERY", payload: { query } });
  };

  const exportExcel = async (request: any) => {
    await execute({
      callback: async () => {
        dispatch({
          type: "LOADING",
          payload: { loading: "create" },
        });
        const data = await EndPoints.category.exportExcel(request, {
          ...state.query,
          filters: state.query.filters,
        });
        const url = window.URL.createObjectURL(new Blob([data.data]));
        const link = document.createElement("a");
        link.href = url;
        link.setAttribute(
          "download",
          `Categories-${moment().format("yyyy-MM-d")}.xlsx`
        );
        document.body.appendChild(link);
        link.click();
      },
      fallback: (error) => {},
      finallyCallback: () => {
        dispatch({
          type: "LOADING",
          payload: { loading: "create" },
        });
      },
      throwException: true,
    });
  };

  return (
    <CategoryContext.Provider
      value={{
        ...state,
        actions: {
          getData,
          getDetails,
          setDetails,
          getAllData,
          createCategory,
          updateCategoriesArrangementList,
          updateCategory,
          deleteCategory,
          exportExcel,

          setSearch,
          setQuery,
        },
      }}
    >
      {props.children}
    </CategoryContext.Provider>
  );
};

export default CategoryContextProvider;
